((root)=>{
'use strict';
const clean=s=>String(s||'').replace(/\s+/g,' ').trim();
const extract=(title,lines,kind='')=>{
 const source=lines.map(clean).filter(Boolean),text=clean([title,...source].join(' ')),facts=[];
 const add=(key,value)=>{if(value&&!facts.some(f=>f[0]===key))facts.push([key,clean(value)]);};
 const first=re=>text.match(re)?.[0];
 const printer=/impresora|multifunci[oó]n/i.test(kind||title);
 const consumable=/t[oó]ner|cartucho|tambor/i.test(kind+' '+title)&&!printer;
 if(consumable){
  add('yield',first(/(?:hasta\s+)?[\d.,]+\s+p[aá]ginas\b/i));
  const compatible=source.find(s=>/(?:compatible con|adecuado para uso en las siguientes impresoras|compatibles con|impresoras compatibles)\s*:/i.test(s));
  if(compatible){
   let value=compatible.split(/(?:compatible con|adecuado para uso en las siguientes impresoras|compatibles con|impresoras compatibles)\s*:/i).slice(1).join(' ').split(/rendimiento|p[aá]ginas capacidad|mostrar m[aá]s|capacidad:/i)[0].trim();
   if(value.length>130)value=value.slice(0,130).replace(/\s+\S*$/,'')+'…';
   add('compatibility',value);
  }
 }
 add('weight',first(/\d+(?:[.,]\d+)?\s*(?:g\s*\/\s*m[²2]|gr\s*\/\s*m[²2]|gsm|gr(?:amos)?\s*\/\s*m[²2])\b/i)||first(/\d+(?:[.,]\d+)?\s*g\s*\/\s*m²/i));
 add('size',first(/\d+(?:[.,]\d+)?\s*(?:mm|cm)?\s*[x×]\s*\d+(?:[.,]\d+)?(?:\s*[x×]\s*\d+(?:[.,]\d+)?)?\s*(?:mm|cm)\b/i)||first(/(?:Ø|di[aá]metro)\s*\d+(?:[.,]\d+)?\s*(?:mm|cm)\b/i)||first(/(?:ancho|anchura)\s*:?\s*\d+(?:[.,]\d+)?\s*(?:mm|cm)\b/i));
 if(!printer)add('contents',first(/\d[\d.,]*\s*(?:hojas|etiquetas|unidades|uds\.?|metros)\b/i));
 if(printer){add('speed',first(/(?:hasta\s+)?\d+(?:[.,]\d+)?\s*(?:ppm|p[aá]ginas por minuto|etiquetas por minuto)\b/i));const connection=source.find(s=>/^(?:-\s*)?(?:conexi[oó]n|conectividad)\s*:/i.test(s));if(connection)add('connection',connection.replace(/^[^:]+:\s*/,''));}
 const material=source.find(s=>/^(?:-\s*)?material(?:es)?\s*:/i.test(s));
 if(material)add('material',material.replace(/^[^:]+:\s*/,''));
 else add('material',title.match(/\b(?:polipropileno|poli[eé]ster|cart[oó]n reciclado|cart[oó]n|pl[aá]stico ABS|acero inoxidable)\b/i)?.[0]);
 add('format',first(/\b(?:DIN\s*)?A[0-6]\b/i));
 add('digits',first(/\d{1,2}\s+d[ií]gitos\b/i));
 return facts.filter(([,v])=>v.length<=180).slice(0,5);
};
if(typeof module!=='undefined'&&module.exports){module.exports={extract};return;}
const boot=()=>document.querySelectorAll('[data-product-facts]').forEach(region=>{
 if(region.dataset.ready)return;region.dataset.ready='true';
 const body=document.getElementById(region.dataset.description)?.querySelector('.rich-content');if(!body)return;
 const clone=body.cloneNode(true);clone.querySelectorAll('script,style,summary,button').forEach(n=>n.remove());
 const lines=[...clone.querySelectorAll('p,li,tr')].map(n=>n.textContent);
 if(!lines.length)lines.push(clone.textContent);
 const facts=extract(region.dataset.title,lines,region.dataset.kind),labels=JSON.parse(region.querySelector('[data-facts-labels]').textContent),list=region.querySelector('dl');
 for(const [key,value]of facts){const row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=labels[key];dd.textContent=value;row.append(dt,dd);list.append(row);}
 region.hidden=!facts.length;
 region.querySelector('a').addEventListener('click',()=>body.querySelectorAll('details').forEach(d=>d.open=true));
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',boot);
root.PrinkProductFacts={extract};
})(typeof window==='undefined'?{}:window);
